import { action, observable, makeObservable } from "mobx";

import { PaginatedAPIResponse } from "../models/NetworkResponse";
import { InventorySwagpack } from "../models/inventory/InventorySwagpack";
import { SwagpackFilters } from "../models/inventory/InventorySwagpackFilter";
import SwagpacksAPI from "../api/SwagpacksAPI";

export class SwagpacksStore {
  customers: any;
  swagpack: InventorySwagpack[];
  limit: number;
  total_pages: number;
  total_count: number;
  swagpacksAPI: SwagpacksAPI;

  constructor() {
    this.swagpack = [];
    this.limit = 0;
    this.total_pages = 0;
    this.total_count = 0;
    this.swagpacksAPI = new SwagpacksAPI();

    makeObservable(this, {
      swagpack: observable,
      getSwagpacks: action,
    });
  }

  getSwagpacks = async (filters: SwagpackFilters) => {
    try {
      const response = (await this.swagpacksAPI.getSwagpacks(
        filters,
      )) as PaginatedAPIResponse<InventorySwagpack>;
      this.limit = response.limit;
      this.total_count = response.total_count;
      this.total_pages = response.total_pages;
      this.swagpack = response.list;
    } catch (error: any) {
      throw error;
    }
  };
}
